import { init as initFrontmanClient } from '@tmap-web-lib/remote-api-client/frontman'
import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import { PropsWithChildren, useCallback, useEffect, useState } from 'react'

import { API } from '@/constants/api'
import { getAccessKey, getDefaultFrontmanHeaders, setAccessKey } from '@/utils/api'
import { isClient } from '@/utils/compare'

export const FrontmanApiClientProvider = ({ children }: PropsWithChildren) => {
  const [isReady, setIsReady] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  if (error) throw error

  const init = useCallback(async () => {
    try {
      const headers = await getDefaultFrontmanHeaders()

      initFrontmanClient({
        hostUrl: API.ENDPOINT.FRONTMAN,
        headers,
        timeout: API.CONFIG.DEFAULT_TIMEOUT,
        async onRequest(config) {
          if (config.url?.includes('proxy')) {
            return config
          }

          const accessKey = await getAccessKey()
          config.headers.AccessKey = accessKey

          return config
        },
        onResponse(response) {
          return response?.data ?? response
        },
        onAccessKeyChanged(newAccessKey: string) {
          if (newAccessKey) {
            TmapApp.updateAccessKey({ key: newAccessKey })
            setAccessKey(newAccessKey)
          }
        },
      })
    }
    catch (error) {
      console.error('[FrontmanApiClientProvider] fail init api client:', error)
      setError(error instanceof Error ? error : new Error(String(error)))
    }
    finally {
      setIsReady(true)
    }
  }, [])

  useEffect(() => {
    if (isClient && !isReady) {
      init()
    }
  }, [isReady, init])

  if (!isReady) return null

  return children
}
